import {createApi} from "@reduxjs/toolkit/dist/query/react";
import {Response} from "../../types/response/Response";
import {CityDTO} from "../../types/city/CityDTO";
import {branchApiQuery} from "../utils/Extensions";


export const cityApi = createApi({
    reducerPath: "city",
    baseQuery: branchApiQuery,
    tagTypes: ["cities"],
    endpoints: builder => ({
        getCities: builder.query<Response<CityDTO[]>, Partial<void>>({
            query: () => '/v1/cities/list',
            providesTags: ["cities"]
        })
    })
})

export const {useGetCitiesQuery} = cityApi